import {Injectable} from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';

import {EMPTY, Observable, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {Constants} from '../utils/constants';
import {Router} from '@angular/router';
import {AppService} from 'src/app/app.service';
import {environment} from 'src/environments/environment';
import {AuthService} from '../../components/authentication/authentication.service';

@Injectable()
export class Interceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private appService: AppService,
    private authen: AuthService) {}
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    // const user = JSON.parse(localStorage.getItem('access_token'));
    const token = localStorage.getItem('access_token');
    const notLoading = request.headers.get('[onlyclient]notLoading') === 'true';
    if (
      request.url.indexOf('.html') >= 0 ||
      request.url.indexOf('.json') >= 0 ||
      request.url.indexOf('.js') >= 0 ||
      request.url.indexOf('.css') >= 0 ||
      request.url.indexOf('.woff') >= 0 ||
      request.url.indexOf('.png') >= 0 ||
      request.url.indexOf('.sgv') >= 0 ||
      request.url.indexOf('.jpg') >= 0 ||
      request.url.indexOf('.jpeg') >= 0 ||
      request.url.indexOf('/assets/') >= 0
    ) {
    } else {
      // if (request.url.indexOf('loading=true')) {
      //   this.appService.startLoading();
      // }
      if (!this.appService.inprocessApis.length && !notLoading) {
        this.appService.startLoading(request.url);
      }
      this.appService.inprocessApis.push(1);
      if (
        Constants.API_WITHOUT_TOKEN.indexOf(
          request.url.replace(environment.url, '/api'),
        ) < 0
      ) {
        // const token = token;
        if (token) {
          request = request.clone({
            headers: request.headers.set('Authorization', 'Bearer ' + token),
          });
        } else {
          const returnUrl =
            this.router.url.indexOf('returnUrl') < 0 ? this.router.url : '';
          this.router.navigate(['/auth/signin'], {
            queryParams: { returnUrl },
          });
          this.appService.completeLoading();
          return EMPTY;
        }
      }

      if (!request.headers.has('Content-Type')) {
        request = request.clone({
          headers: request.headers.set('Content-Type', 'application/json'),
        });
      }

      if (request.headers.has('[onlyclient]notLoading')) {
        request = request.clone({
          headers: request.headers.delete('[onlyclient]notLoading'),
        });
      }

      request = request.clone({
        headers: request.headers.set('Accept', 'application/json'),
      });
    }

    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          if (
            event.hasOwnProperty('body') &&
            event.body.status === 1000 &&
            event.body.token &&
            token
          ) {
            const tk = event.body.token;
            localStorage.setItem('access_token', tk);
            this.authen.startRefreshTokenTimer(); // check timeout refresh token
          } else if (
            event.body.error_code === Constants.RESPONSE_ERROR.INVALID_TOKEN
          ) {
            localStorage.removeItem('access_token');
            if (this.router.url.indexOf('auth') >= 0) {
              this.router.navigate(['/auth/signin']);
            } else {
              const returnUrl =
                this.router.url.indexOf('returnUrl') < 0 ? this.router.url : '';
              this.router.navigate(['/auth/signin'], {
                queryParams: { returnUrl },
              });
            }
            this.appService.completeLoading(request.url);
            this.appService.showError(
              Constants.ERROR_MESSAGE[event.body.error_code]?Constants.ERROR_MESSAGE[event.body.error_code]:Constants.ERROR_MESSAGE.DEFAULT,
              '',
              true,
            );
            return null;
          } else if (
            event.body.status === Constants.RESPONSE_STATUS.FAILED ||
            event.body.status === Constants.RESPONSE_STATUS.PERMISSION_DENIED
          ) {
            this.appService.inprocessApis.splice(0, 1);
            if (!this.appService.inprocessApis.length) {
              this.appService.completeLoading(request.url);
            }
            if (
              event.body.error_code !==
              Constants.RESPONSE_ERROR.INVALID_USERNAME_OR_PASSWORD && !Constants.customErrorMessage.includes(event.body.error_code)
            ) {
              this.appService.showError(
                Constants.ERROR_MESSAGE[event.body.error_code]?Constants.ERROR_MESSAGE[event.body.error_code]:Constants.ERROR_MESSAGE.DEFAULT,
                '',
                true,
              );
              return null;
            }
          }
        }
        localStorage.setItem('jwt_running', '1');
        this.appService.inprocessApis.splice(0, 1);
        if (
          !this.appService.inprocessApis.length &&
          event instanceof HttpResponse &&
          event.body
        ) {
          this.appService.completeLoading(request.url);
        }
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        let data = {};
        data = {
          reason: error && error.error.reason ? error.error.reason : '',
          status: error.status,
        };
        this.appService.inprocessApis.splice(0, 1);
        if (!this.appService.inprocessApis.length) {
          this.appService.completeLoading();
        }
        return throwError(error);
      }),
    );
  }
}
